// ES6 Polyfills

// Plugins

// Bootstrap
//import('bootstrap/js/src/dropdown.js');

// Components
import '../components/accordion';
import '../components/alert';
import '../components/calculator';
import '../components/captcha';
import '../components/footer-contact';
import '../components/forms';
import '../components/form-switch';
import '../components/header';
import '../components/link-icon';
import '../components/popup';
import '../components/popup-contact';
import '../components/popup-image';
import '../components/popup-share';
import '../components/side-navigation';
import '../components/side-anchor-navigation';
import '../components/teaser';

// solr
import '../components/search.js';

// Chat Livezilla
import '../components/chat-livezilla';

// Let the document know when the keyboard is being used
document.body.addEventListener('mousedown', () => {
  document.body.classList.remove('using-keyboard');
});

// Re-enable focus styling when Tab is pressed
document.body.addEventListener('keydown', (e) => {
  if (e.key === 'Tab') document.body.classList.add('using-keyboard');
});

const telephoneLinks = document.querySelectorAll('a[href^="tel:"]');
if (window.matchMedia('(min-width: 768px)').matches) {
  telephoneLinks.forEach((link) => link.setAttribute('tabindex', '-1'));
}

// Function to add a special touch event listener
function addSpecialTouchEvent(eventName, condition) {
  document.addEventListener(
    eventName,
    function(event) {
      // Logic to determine if preventDefault should be called
      var handle = function(e) {
        if (condition) {
          e.preventDefault();
        }
        // Your event handling logic here
      };

      // Check if the condition is met to decide on passive value
      if (condition) {
        // Condition met, add listener with passive set to false
        document.addEventListener(eventName, handle, { passive: false });
      } else {
        // Condition not met, add listener with passive set to true
        document.addEventListener(eventName, handle, { passive: true });
      }
    },
    { once: true }
  ); // Use { once: true } to ensure this setup runs only once per event type
}

// Usage example
var conditionForNoPreventDefault = false; /* your condition to disable preventDefault, e.g., based on some class name or data attribute */

// Setup special touch events
addSpecialTouchEvent('touchstart', conditionForNoPreventDefault);
addSpecialTouchEvent('touchmove', conditionForNoPreventDefault);

// Function to modify links that point to PDFs
function modifyPdfLinks() {
  // Search for all links on the page
  const links = document.querySelectorAll('a');

  // Loop through the links and check if they point to a .pdf file
  links.forEach((link) => {
    const href = link.getAttribute('href');
    const onclick = link.getAttribute('onclick');

    if (!onclick && href && href.toLowerCase().indexOf('.pdf') !== -1) {
      // Get the URL without the content after ".pdf"
      const urlWithoutContent = href.split('.pdf')[0];

      // Modify the link's onclick attribute with the desired function and URL
      link.setAttribute(
        'onclick',
        `window.emos3.send({Target: ['Download', '${urlWithoutContent}', 1, 'd'], content: '${urlWithoutContent}'});`
      );
    }
  });
}

// Call the function to modify the links when the page has finished loading
document.addEventListener('DOMContentLoaded', function() {
  modifyPdfLinks();
});

// replaces this code:

/* eslint-disable */
/*
// Google Lighthouse - Workaround for "Does not use passive listeners to improve scrolling performance"
jQuery.event.special.touchstart = {
    setup(_, ns, handle) {
        if (ns.includes('noPreventDefault')) {
            this.addEventListener('touchstart', handle, { passive: false });
        } else {
            this.addEventListener('touchstart', handle, { passive: true });
        }
    },
};
jQuery.event.special.touchmove = {
    setup(_, ns, handle) {
        if (ns.includes('noPreventDefault')) {
            this.addEventListener('touchmove', handle, { passive: false });
        } else {
            this.addEventListener('touchmove', handle, { passive: true });
        }
    },
};
*/
